import { publishField } from "redux/slices/lensEditor";
import { useAppDispatch } from "redux/hooks";
import { useCallback, useState } from "react";
import { PublishFieldUpdate } from "generated/graphql";
import { PublishModal } from "routes/lens-editor/PublishModal";

interface PublishFieldModalProps {
  lensId: number;
  fieldId: number;
  open: boolean;
  close: () => void;
}

const PublishFieldModal = (props: PublishFieldModalProps) => {
  const { lensId, fieldId } = props;
  const dispatch = useAppDispatch();
  const [updateInfo, setUpdateInfo] = useState<PublishFieldUpdate[]>([]);
  const [dryrun, setDryrun] = useState(true);
  const [error, setError] = useState("");
  const [disabled, setDisabled] = useState(false);

  const handlePublishField = async (dryrun: boolean, onlyPublishLensIds: number[]) => {
    setDisabled(true);
    setDryrun(dryrun);
    return dispatch(
      publishField({
        lensId: lensId,
        fieldId: fieldId,
        dryrun: dryrun,
        onlyPublishLensIds: onlyPublishLensIds,
      })
    )
      .unwrap()
      .then((response) => {
        setUpdateInfo(response.lens.form.publishField.updateInfo);
        setError("");
        setDisabled(false);
      })
      .catch((e) => {
        setError(e.message);
        setDisabled(false);
      });
  };

  const dryrunOnMount = useCallback(() => {
    handlePublishField(true, []);
  }, []);

  return (
    <PublishModal
      ref={dryrunOnMount}
      open={props.open}
      error={error}
      dryrun={dryrun}
      isDisabled={disabled}
      updateInfo={updateInfo}
      close={props.close}
      publish={(onlyPublishLensIds: number[]) => handlePublishField(false, onlyPublishLensIds)}
      header="Publish Field"
      text="Publish Field to the following lenses?"
    />
  );
};

export default PublishFieldModal;
